import React from 'react';

function LineItemsTable({ lineItems, onItemChange, onRemoveItem, formatCurrency }) {
  return (
    <div className="overflow-x-auto">
      <table className="min-w-full border border-gray-300">
        <thead className="bg-bluestar-50">
          <tr>
            <th className="px-4 py-2 border border-gray-300 text-left text-sm font-semibold text-gray-700 w-16">
              #
            </th>
            <th className="px-4 py-2 border border-gray-300 text-left text-sm font-semibold text-gray-700">
              Details
            </th>
            <th className="px-4 py-2 border border-gray-300 text-left text-sm font-semibold text-gray-700 w-32">
              Rate
            </th>
            <th className="px-4 py-2 border border-gray-300 text-left text-sm font-semibold text-gray-700 w-24">
              Tax (%)
            </th>
            <th className="px-4 py-2 border border-gray-300 text-left text-sm font-semibold text-gray-700 w-32">
              Tax Amount
            </th>
            <th className="px-4 py-2 border border-gray-300 text-left text-sm font-semibold text-gray-700 w-32">
              Total
            </th>
            <th className="px-4 py-2 border border-gray-300 text-left text-sm font-semibold text-gray-700 w-20">
              Action
            </th>
          </tr>
        </thead>
        <tbody>
          {lineItems.map((item) => (
            <tr key={item.id} className="hover:bg-gray-50">
              <td className="px-4 py-2 border border-gray-300 text-center">
                {item.serialNumber}
              </td>
              <td className="px-4 py-2 border border-gray-300">
                <textarea
                  value={item.details}
                  onChange={(e) => onItemChange(item.id, 'details', e.target.value)}
                  placeholder="Item description (e.g., Boat rent month of November 2025, 1st Nov 2025 to 30th Nov 2025)"
                  rows="2"
                  className="w-full px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-bluestar-500 text-sm"
                />
              </td>
              <td className="px-4 py-2 border border-gray-300">
                <input
                  type="number"
                  value={item.rate || ''}
                  onChange={(e) => onItemChange(item.id, 'rate', parseFloat(e.target.value) || 0)}
                  placeholder="0.00"
                  step="0.01"
                  min="0"
                  className="w-full px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-bluestar-500 text-sm"
                />
              </td>
              <td className="px-4 py-2 border border-gray-300">
                <input
                  type="number"
                  value={item.taxRate || ''}
                  onChange={(e) => onItemChange(item.id, 'taxRate', parseFloat(e.target.value) || 0)}
                  placeholder="0"
                  step="0.01"
                  min="0"
                  max="100"
                  className="w-full px-2 py-1 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-bluestar-500 text-sm"
                />
              </td>
              <td className="px-4 py-2 border border-gray-300 text-right text-sm">
                {item.taxAmount > 0 ? formatCurrency(item.taxAmount) : '-'}
              </td>
              <td className="px-4 py-2 border border-gray-300 text-right text-sm font-semibold">
                {formatCurrency(item.total)}
              </td>
              <td className="px-4 py-2 border border-gray-300 text-center">
                {lineItems.length > 1 && (
                  <button
                    onClick={() => onRemoveItem(item.id)}
                    className="px-2 py-1 bg-red-500 text-white rounded hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-500 text-sm"
                  >
                    Remove
                  </button>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default LineItemsTable;

